import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
// import FormDialog from '../../components/table/FormDialog';
// import Fab from '@material-ui/core/Fab';
// import AddIcon from '@material-ui/icons/Add';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import axios from 'axios';
import DataTable from '../../modules/itec/view/DataTable';
import SearchBox from '../../components/table/SearchBox';
import FormDialog from '../../components/table/FormDialog';
import { CommonConfig } from '../../config/common-config';
import token from '../../config/token';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import DialogContentText from '@material-ui/core/DialogContentText';
import LoaderPopUp from '../../components/loaderpopup/loader';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    buttonView: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '24%',
        margin: '0px !important',
        background: '#4c4fa6 !important',
        color: 'white !important',
        marginRight: '14px !important',
        fontFamily: 'Rubik',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    pointerEvents: {
        pointerEvents: 'none !important',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
}));
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function AssignTickets(props) {
    const history = useHistory();
    // const [AllImcs, setAllImcs] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    // const [deletedata, setDeleteData] = useState(rows);
    const [openBox, setOpenBox] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState('');
    const [itecMembers, setItecMembers] = useState([]);

    const triggerUseEffect = useSelector((state) => state.serviceCheckListReducer.triggerUseEffect);
    const vertical = 'top';
    const horizontal = 'center';
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const classes = useStyles();

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [openAssignModal, setOpenAssignModal] = useState(false);

    const tokens = token();
    const myRef = useRef();
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [rows, setRowsList] = useState([]);
    let tempArr = [];
    const [selectedValue, setSelectedValue] = useState([]);
    const [assigneeType, setAssigneeType] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [domainName, setDomainName] = useState('');
    const [itecEmpId, setItecEmpId] = useState();

    //console.log("dbname", dbname);
    //console.log("selectedImc", selectedImc);
    //console.log("usertype", usertype);
    let headCells = [
        { id: 'ticketId', label: 'Ticket Number' },
        { id: 'clientId', label: 'Client ID' },

        { id: 'clientName', label: 'Client Name' },
        { id: 'issueId', label: 'Issue relates to', isConcat: 'true', concatElem: ['issueType'] },
        { id: 'ticketTimestamp', label: 'Date' },
        { id: 'statusId', label: 'Current Status', isConcat: 'true', concatElem: ['statusText'] },
    ];

    function formatDate(props) {
        return props.map((element) => {
            if (element && element.ticketTimestamp) {
                element.ticketTimestamp = moment(element.ticketTimestamp).format('DD-MM-YYYY');
                // element.ticketTimestamp = moment(element.ticketTimestamp).format('DD-MM-YYYY hh:mm:ss');
            }
        });
    }

    useEffect(() => {
        // if (searchQuery && searchQuery.length > 2) {
        //     getSearchValue(searchQuery);
        // } else {
        //     setSearchData([]);
        if (history.location && history.location.state && history.location.state.row) {
            setDomainName(history.location.state.row.tennantName);
            setItecEmpId(history.location.state.empid);
        }
        getTicketList();
        getItecEmployees();
        // }
    }, [userToken, page, tokens, props.statusType, props.selectedImc]);

    const getItecEmployees = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s_itec_employee?page=0&size=1000&sort=itecEmpId,desc`, tokens)
            .then((response) => {
                response.data.content.filter((ele) => {
                    if (ele.itecEmpId !== itecEmpId) {
                        return tempArr.push(ele)
                    }
                })
                // console.log('THE FETCHED DATA : ', tempArr);
                setItecMembers(tempArr);
            })
            .catch((error) => {
                //console.log(error);
            });
    }

    const getTicketList = () => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        const bearerToken = `Bearer ${userToken}`;
        let baseURL;

        if (usertype === 'itec') {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get_assigned_ticket_all_inprogress_by_id/${itecEmpId}?page=${page}&size=10&sort=ticketId,desc`;
        } else {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get_assigned_ticket_all_inprogress/${domainName}/${itecEmpId}?page=${page}&size=10&sort=ticketId,desc`;
        }

        axios
            .get(baseURL, tokens)
            .then((response) => {
                formatDate(response.data.content);
                setRowsList(response.data.content);
                setPageDetails(response.data);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => {
                //console.log(error);
            });
    };


    // const { breadCrumbLabel, breadCrumbPath } = props;

    // useEffect(() => {
    //     axios
    //         .get(`${CommonConfig.dev.baseUrl}/api/auth/open-invoices/Advith`, {
    //             headers: {
    //                 Authorization: bearerToken,
    //             },
    //         })
    //         .then((response) => {
    //             //console.log('response.Chandra', response.data.content);
    //             setPendingInvoices(response.data.content);
    //         })
    //         .catch((error) => {});
    // }, [bearerToken, triggerUseEffect]);

    // componentDidMount() {
    //     this.getCandidates();
    //     this.props.history.push({
    //         state: { breadCrumb_label: this.props.breadCrumb_label }
    //     });
    // }

    // const HandleImcChange =(e)=> {
    // alert(e.target.value);

    // };

    const handleSearchQuery = (searchData) => {
        console.log('row', rows)
        setSearchQuery(searchData);
    };

    const getSearchValue = (data) => {
        let baseURL = '';
        console.log('usertype', usertype, props.selectedImc)
        if (usertype === 'SUPERADMIN') {
            baseURL = `${CommonConfig.dev.baseUrl}/api/support/support_ticket_all_inprogress/${props.selectedImc}?search=${data}&page=${page}&size=10`;
        } else if (usertype === 'itec') {
            baseURL = `${CommonConfig.dev.baseUrl}/api/support/get_assigned_ticket_all_inprogress/${props.selectedImc}?search=${data}&page=${page}&size=10`;
        } else {
            baseURL = `${CommonConfig.dev.baseUrl}/api/support/support_ticket_openinprogress/${dbname}?search=${data}&page=${page}&size=10`;
        }
        axios
            .get(baseURL, tokens)
            .then((res) => {
                if (res.data) {
                    console.log('responseresponse11', res.data.content.length);
                    if (res.data.content.length === 0) {
                        console.log('responseresponse', res.data.content.length);
                        setRowsList([]);
                    }
                    // formatDate(res.data.content);
                    // setSearchData(res.data.content);
                    setRowsList([]);
                    if (props.statusType === 'All') {
                        setSearchData(res.data.content);
                    }
                    if (props.statusType === 'Open') {
                        res.data.content.map((ele, i) => {
                            if (ele && ele.statusId && ele.statusId.statusText === 'Open') {
                                tempArr.push(ele);
                            }
                        });
                        setSearchData(tempArr);
                    }
                    if (props.statusType === 'Inprogress') {
                        let tempArr = [];
                        res.data.content.map((ele, i) => {
                            if (ele && ele.statusId && ele.statusId.statusText === 'In Progress') {
                                tempArr.push(ele);
                            }
                        });
                        setSearchData(tempArr);
                    }
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {
            });
    }


    const navigate = () => {
        history.push('/menu/raise-ticket');
    };

    const handleSave = () => { };

    const handleClose = () => {
        setOpenBox(false);
    };

    const handleSelectedValue = (val) => {
        setSelectedValue(val);
    };

    const handleNavigate = () => {

    }

    const handleCount = (val) => {
        if (val === 'prev') {
            if (!pageDetails.first) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (!pageDetails.last) {
                setPage((page) => page + 1);
            }
        }
    };

    const handleChange = (e) => {
        ////console.log('eeee', e.target.value)
        itecMembers.filter((ele, i) => {
            if (ele.itecEmpId.toString() === e.target.value) {
                console.log('aa', ele)
                setAssigneeType(ele);
            }
        });
    };

    const handleAssign = () => {
        console.log('assigneeType', assigneeType);
        console.log('SelectedValue', selectedValue);
        setShowLoader(true);
        let tempArr = [];
        selectedValue.filter((ele, i) => {
            tempArr.push(ele.ticketId);
        });

        let assigneeObj = {
            ticketIds: tempArr,
            assigneeUserId: assigneeType.itecEmpId,
            assigneeUserName: assigneeType.firstName,
            assigneeUserEmail: assigneeType.officeEmail,
        };

        let baseURL = '';
        if (domainName === 'itec') {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/assign_ticket`;
        } else {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/assign_ticket/${domainName}`;
        }

        axios
            .put(baseURL, assigneeObj, tokens)
            .then((response) => {
                ////console.log("SUBMIT RAISE TICKET", response.status);
                if (response.status === 200) {
                    setShowLoader(false);
                    setOpenAssignModal(false);
                    getTicketList();
                    setSelectedValue([]);
                    setTimeout(() => {
                        navigateDeleteEmp();
                    }, 500);
                }
            })
            .catch((error) => {
                // console.error('There was an error!', error.response.data);
            });
    };

    const navigateDeleteEmp = () => {
        let tempTicketArr = [];
        let tempServiceArr = [];
        axios
            .get(`${CommonConfig.dev.baseUrl5080}/api/auth/get_imc_wiseopen_tickets/${itecEmpId}`, tokens) //?page=${page}&size=10&sort=itecUserId,desc
            .then((response) => {
                console.log('aaaa', response)
                tempTicketArr = response.data.content;
            })
            .catch((error) => {
                //console.log(error);
            });
        axios
            .get(`${CommonConfig.dev.baseUrl5080}/api/auth/get_imc_wiseopen_services/${itecEmpId}`, tokens) //?page=${page}&size=10&sort=employeeId,desc
            .then((response) => {
                console.log('bbbb', response)
                tempServiceArr = response.data.content;
            })
            .catch((error) => {
                //console.log(error);
            });
        console.log('itecOpenServices', tempServiceArr)
        console.log('itecOpenTickets', tempTicketArr)
        setTimeout(() => {
            if (tempTicketArr.length === 0 && tempServiceArr.length === 0) {
                history.push({
                    pathname: '/menu/delete-employee',
                    state: { itecEmpId },
                });
            }
        }, 500);

    }

    const allImcsOptions = (vv) => {
        const OptionList = vv.map((data) => <option value={data.itecEmpId}>{data.itecEmpId} - {data.firstName} {data.lastName}</option>);
        ////console.log('OptionList', OptionList)
        return OptionList;
    };

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        getTicketList();
    }

    // const handleDelete = (data) => {
    //     if (data.empId) {
    //         axios
    //             .delete(`${CommonConfig.dev.baseUrl}/api/auth/open-invoices/Advith/${selectedImc}/${data.empId}`)
    //             .then((response) => {
    //                 const { status } = response;
    //                 if (status === 200) {
    //                     const list = rows.filter((m) => m.empId !== data.empId);
    //                     setDeleteData({ rows: list });
    //                     setDeleteMsg('Core employee deleted successfully');
    //                     setOpenBox(true);
    //                 }
    //             })
    //             .catch((e) => {
    //                 //console.log(e);
    //             });
    //     }
    // };

    // const navigate = () => {
    //     history.push('/menu/Core');
    // };
    // const allImcsOptions = (vv) => {
    //     const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
    //     return OptionList;
    // };

    // const setImc = (e) => {
    //     setselectedImc(e.target.value);
    //     axios
    //         .get(`${CommonConfig.dev.baseUrl}/api/auth/open-invoices/Advith/${e.target.value}?page=0&size=1000&sort=empId,desc`)
    //         .then((response) => {
    //             //console.log("response", response.data.content);
    //             setTotalReactPackages(response.data.content);
    //         })
    //         .catch((error) => {
    //             //console.log(error.response.data);
    //             if (error.response.data) {
    //                 setTotalReactPackages([]);
    //             }
    //         });
    // };
    // const { searchQuery } = props;
    // const filtered = searchQuery ? rows.filter((row) => row.firstName.toLowerCase().startsWith(searchQuery.toLowerCase())) : rows;

    // Filtered Row query , but if there are any empty rows doesn't work
    // as per functionality of "some" it should have value

    // const filteredRow = searchQuery
    //     ? rows.filter((row) => {
    //           const query = searchQuery.toLowerCase().trim();
    //           //   ////console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
    //           return headCells
    //               .map((col) => col.id)
    //               .some((key) => {
    //                   //console.log(row[key],"Value of ROW****row[key]");
    //                   return row[key].toString().toLowerCase().includes(query);
    //               });
    //       })
    //     : rows;

    // Filtered Row based on search for nested objects
    const filteredRow = searchQuery
        ? rows.filter((searchRow) => {
            const query = searchQuery.toLowerCase().trim();
            return headCells
                .map((col) => col)
                .some((key) => {
                    if (key.isConcat && searchRow[key.id]) {
                        const subdata = searchRow[key.id];
                        const mergedData = key.concatElem.map((concatdata) => {
                            return concatdata.split('.').reduce((acc, item) => {
                                if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                    if (typeof acc[item] !== 'object') {
                                        return acc[item].toString().toLowerCase().includes(query);
                                    }
                                    return acc[item];
                                }

                                return false;
                            }, subdata);
                        });
                        //console.log(mergedData,"mergeData");

                        return mergedData[0];
                    }
                    if (searchRow[key.id]) {
                        return searchRow[key.id].toString().toLowerCase().includes(query);
                    } else {
                        return false;
                    }
                });
        })
        : rows;

    // const filteredRow = searchData && searchData.length ? searchData : rows;

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}
            <Snackbar open={openBox} anchorOrigin={{ vertical, horizontal }} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    {deleteMsg}
                </Alert>
            </Snackbar>

            <Card className="custom-table">
                <>
                    <div>
                        {/* <Grid container className="main-container field-container"></Grid> */}

                        <CardContent className="card-title-display">
                            <Grid item xs={12} sm={8}>
                                <Typography className="card-title">Assign Pending Tickets{openAssignModal}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} className="card-search">
                                <div className="search-field">
                                    <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} placeholder="Search..." />
                                </div>
                                {usertype === 'SUPERADMIN' ? (
                                    <div className="card-add-button">
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            onClick={() => {
                                                setOpenAssignModal(true);
                                            }}
                                            className={
                                                selectedValue && selectedValue.length && usertype === 'SUPERADMIN'
                                                    ? classes.button
                                                    : classes.pointerEvents
                                            }
                                        >
                                            Assign To Others
                                        </Button>
                                    </div>
                                ) : null}
                            </Grid>
                            <FormDialog row={[]} pageName="core" show="AddIcon" />
                        </CardContent>
                    </div>
                    <CardContent className="card-table-display">
                        {rows && filteredRow.length > 0 ? (
                            <>
                                <DataTable
                                    rows={filteredRow}
                                    headCells={headCells}
                                    saveRow={handleSave}
                                    axiosConfig={bearerToken}
                                    tennantName={dbname}
                                    handleCount={handleCount}
                                    //id={invoiceId}
                                    pageName="core"
                                    // action
                                    pageDetails={pageDetails}
                                    prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                    imcType={props.selectedImc}
                                    ticketType={'myTickets'}
                                    handleSelectedValue={handleSelectedValue}
                                />
                            </>
                        ) : (
                            <div className={classes.noRecord}>
                                <h1>No records to display</h1>
                            </div>
                        )}
                    </CardContent>
                </>
            </Card>
            <Dialog
                onClose={() => {
                    setOpenAssignModal(false);
                }}
                PaperProps={{
                    className: 'QandADailogBox dailogPadding',
                    style: { padding: '20px', width: '60%' },
                }}
                aria-labelledby="form-dialog-title"
                open={openAssignModal}
            >
                {/* <h3 className="filename" style={{ marginTop: '0px', padding: '0px 11px' }}>
                    Assign Ticket
                </h3> */}

                <DialogContent>
                    <DialogContentText
                        id="alert-dialog-description"
                        className={classes.popContent}
                        style={{ fontWeight: '500', fontFamily: 'Rubik' }}
                    >
                        <Grid item xs={12} sm={12} className="main-container">
                            <FormControl fullWidth>
                                <InputLabel htmlFor="book-application" className={classes.inLabel} shrink>
                                    Assign to <span style={{ color: '#ff0a047a' }}>*</span>
                                </InputLabel>
                                <Select
                                    native
                                    // disable
                                    // value={state.tally}
                                    onClick={(e) => {
                                        handleChange(e);
                                    }}
                                    // inputProps={{
                                    //     name: 'Is the firm liable for audit',
                                    //     id: 'book-application',
                                    // }}
                                    className={classes.bottomLine}
                                >
                                    <option aria-label="None" value="" />
                                    {/* <option value={'itec'}>itec</option> */}
                                    {allImcsOptions(itecMembers)}
                                </Select>
                            </FormControl>
                        </Grid>{' '}
                    </DialogContentText>
                </DialogContent>

                <DialogActions className="paddingBtm" style={{ justifyContent: 'flex-start' }}>
                    <Button
                        className={classes.buttonView}
                        variant="contained"
                        component="label"
                        color="default"
                        onClick={() => {
                            setOpenAssignModal(false);
                        }}
                    >
                        Cancel
                    </Button>
                    <Button className={classes.buttonView} variant="contained" component="label" color="default" onClick={handleAssign}>
                        Assign
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
export default AssignTickets;
